import React from "react";

import Header from './common/header';
import Footer from './common/footer';
import chrome from './../../images/browsers/chrome.svg';
import firefox from './../../images/browsers/firefox.png';
import opera from './../../images/browsers/opera.png';
import edge from './../../images/browsers/edge.png';
import safari from './../../images/browsers/safari.png';

export default class Browsers extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className=" text-center">
				<div className="container py-3 my-3">
					<section className="jumbotron">
						<p></p>
				          <h1 className="jumbotron-heading">我们推荐您使用谷歌浏览器</h1>
				          <p>数据管理平台支持高级浏览器，以获取更好的用户体验。</p>
				          <p><img src={chrome} width="68" /></p>
				          <p className="lead text-muted">
				          	谷歌浏览器 Google Chrome
				          </p>
			                  <p className=" text-muted">支持Windows, Mac系统</p>
				          <p>
				            <a href="https://www.google.cn/chrome/" target="_blank" className="btn btn-primary my-2">前往下载</a>
				          </p>
				          <p></p>
				    
				      </section>
					  <p>其它浏览器推荐</p>
				      <div className="row">

						<div className="col-md-6">
			              <div className="card mb-4 shadow-sm">
			                <div className="pt-3 text-center"><img src={safari} width="48" /></div>
			                <div className="card-body">
			                  <p className="card-text lead">Safari浏览器</p>
			                  <p className=" text-muted">Mac系统</p>
			                    <div className="btn-group">
			                      <a href="https://www.apple.com/safari/" target="_blank"  className="btn btn-sm btn-outline-secondary">前往下载</a>
			                    </div>
			                </div>
			              </div>
			            </div>
			            
						<div className="col-md-6">
			              <div className="card mb-4 shadow-sm">
			                <div className="pt-3 text-center"><img src={opera} width="48" /></div>
			                <div className="card-body">
			                  <p className="card-text lead">Opera浏览器</p>
			                  <p className=" text-muted">Windows, Mac系统</p>
			                    <div className="btn-group">
			                      <a href="https://www.opera.com/zh-cn" target="_blank"  className="btn btn-sm btn-outline-secondary">前往下载</a>
			                    </div>
			                </div>
			              </div>
			            </div>

						<div className="col-md-6">
			              <div className="card mb-4 shadow-sm">
			                <div className="pt-3 text-center"><img src={firefox} width="48" /></div>
			                <div className="card-body">
			                  <p className="card-text lead">Firefox浏览器</p>
			                  <p className=" text-muted">Windows, Mac系统</p>
			                    <div className="btn-group">
			                      <a href="http://www.firefox.com.cn/" target="_blank"  className="btn btn-sm btn-outline-secondary">前往下载</a>
			                    </div>
			                </div>
			              </div>
			            </div>

				      </div>

				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/apps/site/browsers.js